module.exports = __webpack_public_path__ + "static/media/basil-blur-close-up-1437267.d1255dd6.png";